export const ENV = {
  AWS_DEFAULT_REGION: process.env.NEXT_PUBLIC_DEFAULT_REGION || 'us-east-1',
  AWS_EMAIL_REGION_MAPPER_URL:
    process.env.NEXT_PUBLIC_CLOUDFRONT_EMAIL_REGION_MAPPER_URL || '',

  BASE_URL_DEFAULT:
    process.env.NEXT_PUBLIC_MATOMO_API_URL || 'http://localhost:8000/py',
  BASE_URL_US:
    process.env.NEXT_PUBLIC_MATOMO_API_URL_US || 'http://localhost:8000/py',
  BASE_URL_EU:
    process.env.NEXT_PUBLIC_MATOMO_API_URL_EU || 'http://localhost:8000/py',

  SUPABASE_URL_US: process.env.NEXT_PUBLIC_SUPABASE_URL_US || '',
  SUPABASE_URL_EU: process.env.NEXT_PUBLIC_SUPABASE_URL_EU || '',
  SUPABASE_URL_DEFAULT: process.env.NEXT_PUBLIC_SUPABASE_URL || '',

  SUPABASE_ANON_KEY_US: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY_US || '',
  SUPABASE_ANON_KEY_EU: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY_EU || '',
  SUPABASE_ANON_KEY_DEFAULT: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || '',

  WEBSOCKET_URL_US: process.env.NEXT_PUBLIC_WEBSOCKET_URL_US || '',
  WEBSOCKET_URL_EU: process.env.NEXT_PUBLIC_WEBSOCKET_URL_EU || '',
  WEBSOCKET_URL_DEFAULT: process.env.NEXT_PUBLIC_WEBSOCKET_URL || '',

  NEST_API_URL_US: process.env.NEXT_PUBLIC_BACKEND_API_URL_US || '',
  NEST_API_URL_EU: process.env.NEXT_PUBLIC_BACKEND_API_URL_EU || '',
  NEST_API_URL_DEFAULT: process.env.NEXT_PUBLIC_BACKEND_API_URL || ''
}
